/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { getSafe } from "../../../utils";
const Wrapper = styled.div`
  width: 100%;
  height: 10px;
  cursor: pointer;
  position: absolute;
  top: 1.875rem;
  transform: translateY(-5%);
  left: 0;
  display: -webkit-flex;
  justify-content: center;
  z-index: 99;
  @media (max-width: 768px) {
    top: 18px;
  }
  .icon-fav {
    @media (max-width: 768px) {
      height: 23px !important;
      width: 23px !important;
    }
    input {
      position: absolute;
      width: 100%;
      height: 100%;
      cursor: pointer;
      top: 0;
      left: 0;
      -webkit-appearance: none;
      z-index: 99999999;
      appearance: none;
    }
    .input {
      &:checked ~ svg path {
        fill: ${({ theme }) => theme.red};
        stroke: ${({ theme }) => theme.red};
      }
      ${(props) =>
        props.checked
          ? `svg path {
        fill: ${({ theme }) => theme.red};
        stroke: ${({ theme }) => theme.red};
      }`
          : null}
    }
    svg {
      .line1,
      .line2 {
        transition: all 0.4s;
      }
    }

    .plus {
      ${(props) =>
        !props.step
          ? `& ~ svg .line1 {
          transform: rotate(45deg) translate(21%, -51%);
        }
        & ~ svg .line2 {
          transform: rotate(45deg) translate(21%, -51%);
        }`
          : null}
    }
    background: ${({ theme }) => theme.white};
    border-radius: 500px;
    width: 3rem;
    height: 3rem;
    display: -webkit-flex;
    justify-content: center;
    position: relative;
    align-items: center;

    svg {
      width: 3rem;
      @media (max-width: 768px) {
        width: 100%;
        left: -1px !important;
        position: relative;
      }
    }
  }
`;
function Fav({
  handleFav,
  plus,
  id,
  tourAddPlace,
  removeAPlace,
  day,
  poi,
  step,
  setStatus,
  exp,
  circuit,
  event,
  todo,
}) {
  const [checked, setChecked] = React.useState(false);
  const { favorites } = useSelector((state) => state.Favorites);
  React.useEffect(() => {
    if (todo || event) {
      getSafe(() =>
        favorites.pois.includes(id) ? setChecked(true) : setChecked(false)
      );
    }
    if (exp) {
      getSafe(() =>
        favorites.experiences.includes(id)
          ? setChecked(true)
          : setChecked(false)
      );
    }
    if (circuit) {
      getSafe(() =>
        favorites.circuits.includes(id) ? setChecked(true) : setChecked(false)
      );
    }
  }, [favorites.circuits, favorites.pois, favorites.experiences]);
  return (
    <Wrapper checked={checked} step={step}>
      {!plus && (
        <div className="icon-fav">
          <input
            className="input"
            type="checkbox"
            checked={checked}
            onChange={(e) => {
              setChecked(e.target.value);
              handleFav(id, e.target.value);
            }}
          />
          <svg
            width="68"
            height="68"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="24" cy="24" r="24" fill="white" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M33.6125 25.4321L24.5042 35L24.5 34.9956L24.4958 35L15.3875 25.4321C13.5375 23.4785 13.5375 20.3485 15.3875 18.3949C17.2315 16.5364 20.1669 16.5364 22.011 18.3949L24.4895 21.0213L24.5 21.0104L24.5105 21.0213L26.9869 18.3949C28.8312 16.535 31.7682 16.535 33.6125 18.3949C35.4625 20.3485 35.4625 23.4785 33.6125 25.4321V25.4321Z"
              stroke="black"
              stroke-width="2"
            />
          </svg>
        </div>
      )}
      {plus && (
        <div className="icon-fav">
          <input
            className={!step ? "plus" : "plusC"}
            type="checkbox"
            onChange={() => {
              !step && removeAPlace(day, poi._id);
              step &&
                Object.assign(poi, {
                  longitude: poi.location.coordinates[0],
                  latitude: poi.location.coordinates[1],
                });
              step && tourAddPlace(day, poi, step);
              tourAddPlace && setStatus(false);
            }}
          />
          <svg
            width="68"
            height="68"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="24" cy="24" r="24" fill="white" />
            <line
              className="line1"
              x1="23.7664"
              y1="15.6934"
              x2="23.7664"
              y2="33.965"
              stroke="black"
              stroke-width="1.4"
            />
            <line
              className="line2"
              x1="14.6914"
              y1="24.8908"
              x2="32.963"
              y2="24.8908"
              stroke="black"
              stroke-width="1.4"
            />
          </svg>
        </div>
      )}
    </Wrapper>
  );
}

export default Fav;
